import { render } from "./Training.vue?vue&type=template&id=4b196b2a&scoped=true"
import script from "./Training.vue?vue&type=script&lang=js"
export * from "./Training.vue?vue&type=script&lang=js"

import "./Training.vue?vue&type=style&index=0&id=4b196b2a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b196b2a"]])

export default __exports__